import { TrelloServiceComponent } from './TrelloServiceComponent';
export const TrelloReconnectionConfig = {
  serviceComponent: TrelloServiceComponent
};